import { computed } from '@angular/core';
import { StateSignals } from '@ngrx/signals';
import { FileExportState } from './file-export.store';

export const fileExportComputed = (state: StateSignals<FileExportState>) => ({
  currentDownloadingFilesLength: computed(() => {
    const files = state.files();
    return files.filter((file) => file.status === 'pending').length;
  }),
  hasErrorDuringDownloadingOccurred: computed(() => {
    const files = state.files();
    return files.some((file) => file.status === 'failed');
  }),
});
